import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

interface MobileMenuProps {
    isOpen: boolean;
    onClose: () => void;
}

// Use a transient prop (prefix with $)
const Overlay = styled.div<{ $isOpen: boolean }>`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 65%;
    max-width: 400px;
    background-color: white;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    transform: translateX(${({$isOpen}) => ($isOpen ? '0' : '100%')});
    transition: transform 0.3s ease-in-out;
    z-index: 1000;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 10px;
    left: 20px;
    background: none;
    border: none;
    font-size: 2rem;
    color: #333;
    cursor: pointer;
`;

const MenuList = styled.ul`
    list-style: none;
    padding: 40px 20px;
    margin: 0;
`;

const MenuItem = styled.li`
    margin: 20px 0;

    &:not(:last-child) {
        border-bottom: 1px solid #eee;
        padding-bottom: 12px;
    }
`;

const MenuLink = styled(Link)`
    color: #333;
    text-decoration: none;
    font-size: 1.1rem;
    display: block;
`;

const MobileMenu: React.FC<MobileMenuProps> = ({isOpen, onClose}) => {
    return (
        <Overlay $isOpen={isOpen}>
            <CloseButton onClick={onClose}>×</CloseButton>
            <MenuList>
                <MenuItem>
                    <MenuLink to={"/"} onClick={onClose}>Home</MenuLink>
                </MenuItem>
                <MenuItem>
                    <MenuLink to={"/about"} onClick={onClose}>About</MenuLink>
                </MenuItem>
                <MenuItem>
                    <MenuLink to={"/portfolio"} onClick={onClose}>Portfolio</MenuLink>
                </MenuItem>
                <MenuItem>
                    <MenuLink to={"/class"} onClick={onClose}>Class</MenuLink>
                </MenuItem>
                <MenuItem>
                    <MenuLink to={"/shop"} onClick={onClose}>Shop</MenuLink>
                </MenuItem>
                <MenuItem>
                    <MenuLink to={"/rental"} onClick={onClose}>Rêve moiré rental</MenuLink>
                </MenuItem>
                <MenuItem>
                    <MenuLink to={"/contact"} onClick={onClose}>Contact</MenuLink>
                </MenuItem>
            </MenuList>
        </Overlay>
    );
};

export default MobileMenu;
